"use client"

import type React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"
import { InfoIcon } from "lucide-react"
import { cn } from "@/lib/utils"

interface TooltipWrapperProps {
  content: string
  className?: string
}

export const TooltipWrapper: React.FC<TooltipWrapperProps> = ({ content, className }) => {
  return (
    <TooltipPrimitive.Provider delayDuration={100}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>
          <button className={cn("ml-1 text-gray-400 hover:text-gray-600 focus:outline-none bg-transparent", className)}>
            <InfoIcon className="h-4 w-4" />
          </button>
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Content
          sideOffset={5}
          className={cn(
            "z-50 overflow-hidden rounded-md bg-gray-100 px-3 py-1.5 text-sm text-gray-900 shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
            "max-w-md", // Updated max-width class
          )}
        >
          {content}
          <TooltipPrimitive.Arrow className="fill-gray-100" />
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  )
}

